import React from 'react';
import FullWidthContainer from '../Layout/Containers/FullWidthContainer';
import styles from './trustedBy.module.scss';
import { MediaComponent } from '../util/MediaComponent/MediaComponent';

type LogoSize = 'sm' | 'tall' | 'xl';

interface Logo {
    file: string;
    name: string;
    size?: LogoSize;
}

const logos: Logo[] = [
    { file: 'gard.png', name: 'Gard', size: 'tall' },
    { file: 'marsh.png', name: 'Marsh' },
    { file: 'heineken.png', name: 'Heineken' },
    { file: 'statkraft.png', name: 'Statkraft', size: 'xl' },
    { file: 'wtw.png', name: 'WTW', size: 'sm' },
    { file: 'equinor.png', name: 'Equinor' },
    { file: 'vanbreda.png', name: 'Vanbreda' },
    { file: 'fremtind.png', name: 'Fremtind', size: 'sm' },
    { file: 'gjensidige.png', name: 'Gjensidige' },
];

// The track holds the logo set twice so the -50% scroll loops seamlessly;
// the copy is hidden from screen readers.
const LogoGroup = ({ hidden = false }: { hidden?: boolean }) => (
    <div className={styles.homeMgroup} aria-hidden={hidden || undefined}>
        {logos.map((logo) => (
            <MediaComponent
                key={logo.file}
                src={`/images/customer-logos/${logo.file}`}
                alt={hidden ? '' : logo.name}
                extraClassNames={`${styles.homeMlogo} ${logo.size ? styles[logo.size] : ''}`}
            />
        ))}
    </div>
);

const TrustedByComponent = () => (
    <FullWidthContainer>
        <section className={styles.homeTrust}>
            <span className={styles.ingress}>
                Insurers, brokers and risk owners running on Noria
            </span>
            <div className={styles.homeMarquee}>
                <div className={styles.homeMtrack}>
                    <LogoGroup />
                    <LogoGroup hidden />
                </div>
            </div>
        </section>
    </FullWidthContainer>
);

export default TrustedByComponent;
